<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <contact-card :user="currentUser.user_types.producer"
                               :business="currentUser.user_types.business" type="producer"></contact-card>
            </div>
            <div class="col-md-6">
                <b-form @submit="save">
                    <b-form-group
                            id="input-group-1"
                            label="Email address:"
                            label-for="input-1"
                            description="We'll never share your email with anyone else."
                    >
                        <b-form-input
                                id="input-1"
                                v-model="producer.email"
                                type="email"
                                required
                                placeholder="Enter email"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-2"
                            label="First Name:"
                            label-for="input-2"
                    >
                        <b-form-input
                                id="input-2"
                                v-model="producer.first_name"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-3"
                            label="Last Name:"
                            label-for="input-3"
                    >
                        <b-form-input
                                id="input-3"
                                v-model="producer.last_name"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-4"
                            label="Title:"
                            label-for="input-4"
                    >
                        <b-form-input
                                id="input-4"
                                v-model="producer.title"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-5"
                            label="Phone:"
                            label-for="input-5"
                    >
                        <b-form-input
                                id="input-5"
                                v-model="producer.phone"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-6"
                            label="Fax:"
                            label-for="input-6"
                    >
                        <b-form-input
                                id="input-6"
                                v-model="producer.fax"
                                type="text"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            id="input-group-7"
                            label="NPN:"
                            label-for="input-7"
                    >
                        <b-form-input
                                id="input-7"
                                v-model="producer.npn"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary">Submit</b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ContactCard from '../../../components/Dashboard/ContactCard'

    export default {
        name: 'ProducerUpdate',
        components: {ContactCard},
        computed: {
            ...mapGetters(['currentUser']),
            producer () {
                return {
                    email: this.currentUser.email,
                    first_name: this.currentUser.user_types.producer.first_name,
                    last_name: this.currentUser.user_types.producer.last_name,
                    title: this.currentUser.user_types.producer.title,
                    phone: this.currentUser.user_types.producer.phone,
                    fax: this.currentUser.user_types.producer.fax,
                    npn: this.currentUser.user_types.producer.npn,
                }
            }
        },
        methods:{
            save(evt) {
                evt.preventDefault()
                console.log(this.producer)
            }
        }
    }
</script>

<style scoped>

</style>
